<template>
  <div class="dis-info mask">
    <rich-loading v-show="loading" class="dis-info-mask-loading"></rich-loading>
    <i class="richic-aim position-icon" @click="getPosition"></i>
    <div class="dis-info-biz">
      <p class="dis-info-biz-text">{{gettext('当前位置距商家')}} {{ !value.distance && value.distance !== 0 ? '' : value.distance }} {{gettext('米')}}</p>
      <p class="dis-info-biz-text">{{gettext('商家位置为')}}：{{value.shopAddr || '-'}}（{{gettext('依据门店POI反解')}}）</p>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { initVisit } from '@/api/visit'
  import { getLocation } from '@/common/utils/geo'
  export default {
    name: 'ext-info',
    components: {},
    data () {
      return {
        loading: false
      }
    },
    computed: {
      ...mapState(['geo'])
    },
    props: {
      value: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    mounted () {
      this.getPosition()
    },
    methods: {
      async getPosition () {
        this.loading = true
        const geo = await getLocation()
        const visitInitInfo = await initVisit({
          shopId: this.$route.query.shopId,
          lat: geo.lat,
          lng: geo.lng
        })
        this.$emit('input', {
          distance: visitInitInfo.shopDistance || 0,
          shopAddr: visitInitInfo.shopAddr || ''
        })
        this.loading = false
      }
    }
  }
</script>
<style lang="scss" scoped>
  .dis-info {
    position: relative;
    .dis-info-biz{
      display: inline-block;
      .dis-info-biz-text {
        display: inline-block;
        word-break:break-all;
      }
    }
    .position-icon{
      display: inline-block;
      position: absolute;
      top:-80px;
      right: 0px;
      vertical-align: top;
      font-size: $fontsize-large-xxxx;
      color: #ff6325;
    }
  }
  .mask{
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .dis-info-mask-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -32px;
    margin-top: -32px;
  }
</style>
